import { _updateUsers } from "../constants/api";

export const getAllUsers = async (filter = '', currentPage = 1, usersPerPage = 20) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }
    const searchQuery = `search=${filter}&page=${currentPage}&pagelimit=${usersPerPage}`;

    const apiUrl = `${_updateUsers}/searchAllUser/?${searchQuery}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch users');
    }

    const responseJSON = await response.json();
    return responseJSON;

  } catch (error) {
    console.log('Error occurred in the getAllUsers API ==> ', error);
    throw error; 
  }
};


export const updateUsers = async (id, updatedData) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_updateUsers}/${id}`, {
      method: 'PUT', // Use PATCH or PUT depending on your API design
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: JSON.stringify(updatedData), // Pass the updated roles or other data
    });

    if (!response.ok) {
      throw new Error(`Failed to update user: ${response.statusText}`);
    }

    const responseJSON = await response.json();
    return responseJSON;

  } catch (error) {
    console.log('Error occurred in the updateUsers API ==> ', error);
    throw error; // Re-throw error for handling in the calling function
  }
};

export const deleteUsers = async (id) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_updateUsers}/${id}`, {
      method: 'DELETE', 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete user: ${response.statusText}`);
    }

    const responseJSON = await response.json();
    return responseJSON;

  } catch (error) {
    console.log('Error occurred in the delete API ==> ', error);
    throw error;
  }
};
